import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Providers & Layouts
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/MainLayout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import WorkerView from './pages/WorkerView';
import KanbanBoard from './pages/KanbanBoard';
import TableView from './pages/TableView';
import OrderEntry from './pages/OrderEntry';
import NotificationSettings from './components/NotificationSettings'; // Admin Only

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          
          {/* Public Authentication Route */}
          <Route path="/login" element={<Login />} />

          {/* Secure Application Shell */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            {/* Default Landing Page post-login */}
            <Route index element={<Navigate to="/worker-view" replace />} />
            
            {/* Core Worker Accessible Routes */}
            <Route path="worker-view" element={<WorkerView />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="kanban" element={<KanbanBoard />} />
            <Route path="table" element={<TableView />} />
            <Route path="create-order" element={<OrderEntry />} />
            <Route path="edit-order/:id" element={<OrderEntry />} />

            {/* Admin-Restricted Routes */}
            <Route 
              path="admin/settings" 
              element={
                <ProtectedRoute allowedRoles={['Admin']}>
                  <NotificationSettings />
                </ProtectedRoute>
              } 
            />
            
            {/* Graceful Unauthorized Fallback */}
            <Route 
              path="unauthorized" 
              element={
                <div className="flex flex-col items-center justify-center h-full text-center">
                  <span className="text-6xl mb-4">⛔</span>
                  <h2 className="text-2xl font-bold text-gray-800">Access Denied</h2>
                  <p className="text-gray-500 mt-2">You do not have permission to view this page.</p>
                </div>
              } 
            />
          </Route>

          {/* Catch-All 404 Route → Boots back to root (which resolves to worker-view) */}
          <Route path="*" element={<Navigate to="/" replace />} />
          
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;